import { useAuth } from '@/context/AuthContext';
import { CreditCardFilled, BellFilled } from '@ant-design/icons';
import { Menu } from 'antd';
import { Edit, Lock, UserCircle } from 'lucide-react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

export default function ProfileLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const currentPath = location.pathname.split('/').pop() || '';
  const selectedKey = currentPath === 'profile' ? '' : currentPath;
  const { userRole } = useAuth();
  const isOwner = userRole === 'OWNER';

  const menuItems = [
    {
      key: '',
      icon: <UserCircle size={16} />,
      label: 'overview',
    },
    {
      key: 'edit',
      icon: <Edit size={16} />,
      label: 'Edit Profile',
    },
    {
      key: 'password',
      icon: <Lock size={16} />,
      label: 'Password',
    },
    ...(isOwner
      ? [
          {
            key: 'billing',
            icon: <CreditCardFilled size={16} />,
            label: 'Billing',
          },
        ]
      : []),
    {
      key: 'notifications',
      icon: <BellFilled style={{ color: '#ff9900' }} />,
      label: 'Notifications',
    },
    // {
    //   key: "invoices",
    //   icon: <FileTextFilled size={16} />,
    //   label: "Invoices",
    // },
  ];

  return (
    <div className="flex flex-col md:flex-row gap-4">
      <div className="w-full md:w-64 flex-shrink-0">
        <Menu
          mode="vertical"
          selectedKeys={[selectedKey]}
          items={menuItems}
          style={{
            padding: 5,
            borderRadius: 5,
          }}
          onClick={({ key }) =>
            navigate(`/dashboard/profile${key ? `/${key}` : ''}`)
          }
        />
      </div>

      <div className="flex-1">
        <Outlet />
      </div>
    </div>
  );
}
